module.exports = __webpack_public_path__ + "img/download.bc779ce.png";